import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGroupGetService } from '../../services';

export const fetchFormGroupGet = createAsyncThunk(
    'formGroupGet/fetchFormGroupGet',
    async ({ id }) => {
        const response = await FormGroupGetService(id)
        return response.result;
    }
);

const formGroupGetSlice = createSlice({
    name: 'formGroupGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGroupGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGroupGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGroupGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGroupGetSlice.reducer;
